"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildIsReviewedFilter = exports.buildLastReviewedByFilter = exports.stripReviewAttributeFilters = exports.REVIEWED_STATUS_FIELD = void 0;
const graphql_1 = require("../../../../__generated__/graphql");
const client_utils_1 = require("../../../common/table-filter/client.utils");
const attributes_1 = require("../../../constants/attributes");
exports.REVIEWED_STATUS_FIELD = 'reviewedStatus';
const LAST_REVIEWED_BY_FIELD = attributes_1.CustomProductAttributes.LastReviewedBy;
/**
 * Mapping from BE ProductAttributeReviewStatus enum values to FE table filter option values.
 */
const REVIEW_STATUS_MAP = {
    [graphql_1.ProductAttributeReviewStatus.NotReviewed]: 'NotReviewed',
    [graphql_1.ProductAttributeReviewStatus.Reviewed]: 'Reviewed',
};
/**
 * Resolves which reviewed statuses remain selected for the bounded {Reviewed, NotReviewed} option set.
 * Handles both "Is Any Of" (`list`) and "Is Not" (`excludedValues`, with or without `selectAll`) representations.
 */
const resolveIncludedReviewedStatuses = (filter) => {
    var _a, _b;
    const excluded = (_a = filter.excludedValues) !== null && _a !== void 0 ? _a : [];
    if (filter.selectAll || excluded.length > 0) {
        return Object.values(REVIEW_STATUS_MAP).filter((status) => !excluded.includes(status));
    }
    const list = (_b = filter.list) !== null && _b !== void 0 ? _b : [];
    return Object.values(REVIEW_STATUS_MAP).filter((status) => list.includes(status));
};
/**
 * Splits the reviewed-status item out of the table filter. The reviewed status lives at the top-level
 * `isReviewed` field (not inside `ProductFilter`), so it must be stripped before running the standard
 * filter builders to avoid producing a bogus label attribute filter.
 */
const stripReviewAttributeFilters = (tableFilter) => {
    const reviewedFilterItem = tableFilter.items.find((item) => item.field === exports.REVIEWED_STATUS_FIELD);
    const lastReviewedByFilterItem = tableFilter.items.find((item) => item.field === LAST_REVIEWED_BY_FIELD);
    const filteredTableFilter = reviewedFilterItem || lastReviewedByFilterItem
        ? Object.assign(Object.assign({}, tableFilter), { items: tableFilter.items.filter((item) => (item.field !== exports.REVIEWED_STATUS_FIELD
                && item.field !== LAST_REVIEWED_BY_FIELD)) }) : tableFilter;
    return { filteredTableFilter, reviewedFilterItem, lastReviewedByFilterItem };
};
exports.stripReviewAttributeFilters = stripReviewAttributeFilters;
const buildLastReviewedByFilter = (lastReviewedByFilterItem, reviewStatus) => {
    if (!lastReviewedByFilterItem || !reviewStatus) {
        return undefined;
    }
    const _a = lastReviewedByFilterItem.filter, { operator } = _a, filter = __rest(_a, ["operator"]);
    return {
        attribute: reviewStatus.attribute,
        attributeType: reviewStatus.attributeType,
        collaborator: (0, client_utils_1.createCollaboratorFilter)(filter, operator),
    };
};
exports.buildLastReviewedByFilter = buildLastReviewedByFilter;
/**
 * Builds the top-level `isReviewed` filter for a specific attribute from a reviewed-status table item.
 * Returns `undefined` unless exactly one of the two known statuses remains selected (both selected or
 * no review attribute means "no reviewed constraint").
 */
const buildIsReviewedFilter = (reviewedFilterItem, reviewStatus) => {
    if (!reviewedFilterItem || !reviewStatus) {
        return undefined;
    }
    const includedStatuses = resolveIncludedReviewedStatuses(reviewedFilterItem.filter);
    if (includedStatuses.length !== 1) {
        return undefined;
    }
    return {
        value: includedStatuses[0] === REVIEW_STATUS_MAP[graphql_1.ProductAttributeReviewStatus.Reviewed],
        attribute: reviewStatus.attribute,
        attributeType: reviewStatus.attributeType,
    };
};
exports.buildIsReviewedFilter = buildIsReviewedFilter;
